import React, { useState, useEffect } from "react";
import _ from "lodash";
import {
  TextInput,
  Select,
  Textarea,
  NumberInput,
  Group,
  Title,
  Text,
  Divider,
  Button,
  Box,
  Flex,
  Card,
  Menu,
  Grid,
} from "@mantine/core";

import ArrayTable from "./arrayTable";
import { DATA_CURRENCY } from "../data/options";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";
import { useFormatter } from "../hooks/useFomatter";
import { useForceUpdate } from "@mantine/hooks";
import { IconAlertTriangle } from "@tabler/icons-react";
import JsonViewer from "./common/jsonViewer";
import InvoicePaymentHistory from "./invoicePaymentHistory";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/useServerApi";

const calculateTotal = (
  charges,
  discountAmount,
  paymentPercentage,
  paidAmount
) => {
  if (_.isEmpty(charges)) return { sumTotal: 0, total: 0 };

  charges.forEach((c) => {
    c.price = (c.qty ?? 1) * c.unitPrice;
  });

  const sumTotal = +charges
    ?.reduce((a, c) => a + (c.qty ?? 1) * c.unitPrice, 0)
    .toFixed(2);

  const total = +(sumTotal - discountAmount).toFixed(2);
  const amount = (total * paymentPercentage) / 100;
  const balance = amount - paidAmount;

  console.log("calculateTotal = ", sumTotal, total, amount, balance);
  return { sumTotal, total, amount, balance };
};

const InvoiceItems = ({ form, name }) => {
  const items = _.get(form.values, "rows");
  const { amount, balance } = form.values ?? {}; //Invoice
  const total = _.get(form.values, "total") ?? 0;
  const sumTotal = _.get(form.values, "sumTotal") ?? 0;
  const paidAmount = _.get(form.values, "paidAmount") ?? 0;
  const paymentPercentage = _.get(form.values, "paymentPercentage") ?? 0;
  const [api] = useServerApi();

  // const [total, setTotal] = useState(_.get(form.values, "total") ?? 0);
  // const [sumTotal, setSumTotal] = useState(_.get(form.values, "sumTotal") ?? 0);
  const discountAmount = _.get(form.values, "discountAmount") ?? 0;

  const [formatter] = useFormatter();
  const forceUpdate = useForceUpdate();

  const rowInitValue = {
    item: "",
    currency: "HKD",
    qty: 1,
    unitPrice: 0,
    price: 0,
  };

  const fields = [
    {
      header: "Item",
      headerWidth: "50%",
      fieldName: "item",
      component: Textarea,
      props: {
        autosize: true,
        minRows: 1,
      },
    },

    {
      header: "Qty",
      headerWidth: "10%",
      fieldName: "qty",
      component: NumberInput,
      props: {},
    },
    // {
    //   header: "Currency",
    //   headerWidth: "10%",
    //   fieldName: "currency",
    //   component: Select,
    //   props: {
    //     data: DATA_CURRENCY,
    //     defaultValue: "HKD",
    //     searchable: true,
    //   },
    // },
    {
      header: "Unit Price",
      headerWidth: "15%",
      fieldName: "unitPrice",
      component: NumberInput,
      props: {
        thousandSeparator: ",",
        precision: 2,
      },
    },
    {
      header: "Price",
      headerWidth: "15%",
      fieldName: "price",
      component: NumberInput,
      props: {
        thousandSeparator: ",",
        precision: 2,
      },
    },
  ];

  const onItemChange = (charges) => {
    const { sumTotal, total, amount, balance } = calculateTotal(
      charges,
      discountAmount,
      paymentPercentage,
      paidAmount
    );
    form.setFieldValue("rows", charges);
    form.setFieldValue("total", total);
    form.setFieldValue("sumTotal", sumTotal);
    form.setFieldValue("amount", amount);
    form.setFieldValue("balance", balance);
  };

  useEffect(() => {
    const { sumTotal, total, amount, balance } = calculateTotal(
      items,
      discountAmount,
      paymentPercentage,
      paidAmount
    );
    form.setFieldValue("total", total);
    form.setFieldValue("sumTotal", sumTotal);
    form.setFieldValue("amount", amount);
    form.setFieldValue("balance", balance);
  }, [discountAmount, paymentPercentage]);

  const { t } = useTranslation();

  //Load Cost Item from Production
  const loadProductionByGroup = async () => {
    try {
      const projectId = _.isObject(form.values?.project)
        ? form.values?.project?._id
        : form.values?.project;
      if (!projectId) return;
      const result = await api.Project.getProductionCostItemsByGroup(projectId);
      // console.log(result);
      if (!result || _.isEmpty(result.costItems)) return;

      const rows = _.get(form.values, "rows") ?? [];
      form.setFieldValue("rows", [...rows, ...result?.costItems]);
    } catch (e) {
      console.log(e);
    }
  };

  const loadProduction = async () => {
    try {
      const projectId = _.isObject(form.values?.project)
        ? form.values?.project?._id
        : form.values?.project;
      if (!projectId) return;
      const result = await api.Project.getProductionCostItems(projectId);
      // console.log("loadProductionByItem", result);
      if (!result || _.isEmpty(result.costItems)) return;

      const rows = _.get(form.values, "rows") ?? [];
      form.setFieldValue("rows", [...rows, ...result?.costItems]);
    } catch (e) {
      console.log(e);
    }
  };

  // const loadProduction = async () => {
  //   try {
  //     // console.log("loadProduction", form.values.project);
  //     const projectId = _.isObject(form.values?.project)
  //       ? form.values?.project?._id
  //       : form.values?.project;
  //     if (!projectId) return;
  //     const result = await api.Project.getProductionCostItems(projectId);
  //     console.log(result);
  //     if (!result || _.isEmpty(result.costItems)) return;

  //     const rows = _.get(form.values, "rows") ?? [];
  //     form.setFieldValue("rows", [...rows, ...result?.costItems]);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const clearItems = () => {
    const ans = window.confirm("Are you sure to clear all items?");
    if (!ans) return;
    // console.log("clearItems");
    items.length = 0;
    form.setFieldValue("rows", []);
  };

  return (
    <>
      <JsonViewer src={form.values} />
      {/* total:{total} */}
      <Group justify="right" mb="xl">
        <Menu shadow="md" width={200}>
          <Menu.Target>
            <Button variant="default" size="xs">
              {t("Load Production")}
            </Button>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Label>By</Menu.Label>
            <Menu.Item onClick={loadProductionByGroup}>
              {t("Section Groups")}
            </Menu.Item>
            <Menu.Item onClick={loadProduction}>
              {t("Individual Items")}
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
        <Button variant="default" size="xs" onClick={clearItems}>
          {t("Clear All")}
        </Button>
      </Group>
      <ArrayTable
        form={form}
        name={"rows"}
        rowInitValue={rowInitValue}
        fields={fields}
        onDataChange={onItemChange}
      />
      <Divider my="xl" />
      <Grid>
        <Grid.Col span={6}>
          {/* <InvoicePaymentHistory form={form} /> */}
        </Grid.Col>

        <Grid.Col span={6}>
          <Box>
            <Group justify="space-between" mb="xs">
              <Text size="xs" c={"dimmed"}>
                {t("Sum Total")}
              </Text>
              <Text>{formatter.currency(sumTotal)}</Text>
            </Group>
            <Group justify="space-between" mb={"xs"}>
              <Text size="xs" c={"dimmed"}>
                {t("Discount")}
              </Text>
              <NumberInput
                precision={2}
                thousandSeparator=","
                placeholder="10"
                value={discountAmount}
                size="xs"
                onChange={(v) => {
                  form.setFieldValue("discountAmount", v);

                  calculateTotal(items, v, paymentPercentage);
                }}
              />
            </Group>
            <Divider variant="dotted" my={"lg"} />
            <Group justify="space-between" mb="xs">
              <Text size="xs" c={"dimmed"}>
                {t("Total")}
              </Text>
              <Text>{formatter.currency(total)}</Text>
            </Group>

            <Group justify="space-between" mb="xs">
              <Text size="xs" c={"dimmed"}>
                {t("Payment %")}
              </Text>
              <NumberInput
                precision={2}
                thousandSeparator=","
                placeholder="10"
                value={paymentPercentage}
                size="xs"
                onChange={(v) => {
                  form.setFieldValue("paymentPercentage", v);
                  // calculateTotal(items, discountAmount, v, paidAmount);
                }}
              />
            </Group>

            <Group justify="space-between" mb="xs">
              <Text size="xs" c={"dimmed"}>
                {t("Invoice Amount")}
              </Text>
              <Text>{formatter.currency(amount)}</Text>
            </Group>
            {/* <Divider variant="dotted" my={"lg"} />

            <Group justify="space-between" my="xs">
              <Text>Total Due</Text>
              <Title order={3}>{formatter.currency(balance)}</Title>
            </Group> */}
          </Box>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default InvoiceItems;
